<template>
    <div class="relative">
        <input :v-model="data" class="w-full p-4 bg-white rounded-lg focus:outline-none" type="text" :placeholder="placeholder"
            @input="$emit('input', $event.target.value)" />
        <span v-if="showIcon" class="absolute top-0 right-0 bottom-0 flex flex-row-reverse w-full pr-2">
            <i :class="setIcon" class="icon-color"></i>
        </span>
    </div>
</template>
  
<script>
export default {
    name:"NSInput",
    props: {
        placeholder: {
            type: String,
            default: 'Enter text...',
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
        setIcon: {
            type: String,
            default: 'el-icon-search',
        },
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            data:this.value
        }
    }
};
</script>
  
<style scoped>
input::placeholder {
    color: #999999;
}

.icon-color {
    color: #333333;
}

.bottom-0 {
    bottom: 15px;
}
</style>